// WizardHeader component matching the HTML design exactly
import React from "react";

interface WizardHeaderProps {
  title: string;
  currentStep: number;
  totalSteps: number;
  onBack?: () => void;
  onClose?: () => void;
  mode?: "create" | "edit";
}

const WizardHeader: React.FC<WizardHeaderProps> = ({
  title,
  currentStep,
  totalSteps,
  onBack,
  onClose,
  mode = "create",
}) => {
  return (
    <header className="tw-border-b tw-border-gray-200 dark:tw-border-[#233648] tw-bg-white dark:tw-bg-[#1C252E] tw-px-4 md:tw-px-6 tw-py-4">
      <div className="tw-flex tw-items-center tw-justify-between">
        <div className="tw-flex tw-items-center tw-gap-3">
          {onBack && (
            <button
              onClick={onBack}
              className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-gray-100 dark:tw-bg-gray-800 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-transition-colors"
              aria-label="Go back"
            >
              <span className="material-symbols-outlined tw-text-xl tw-text-gray-600 dark:tw-text-gray-300">
                arrow_back
              </span>
            </button>
          )}
          <div>
            <h1 className="tw-text-lg md:tw-text-xl tw-font-bold tw-text-gray-900 dark:tw-text-white">
              {mode === "create" ? "Create New Product" : "Edit Product"}
            </h1>
            <p className="tw-text-xs md:tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
              Step {currentStep} of {totalSteps}
            </p>
          </div>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center hover:tw-bg-gray-100 dark:hover:tw-bg-gray-800 tw-rounded-lg tw-transition-colors"
            aria-label="Close wizard"
          >
            <span className="material-symbols-outlined tw-text-gray-500 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-200">
              close
            </span>
          </button>
        )}
      </div>
    </header>
  );
};

export default WizardHeader;
